import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";

const DoNotKnowPriceSwapStep_1 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.step_3);
  };

  const handleNextStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_2);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNextStep}
        text="Нажимая 'Далее >' подтверждаю стоимость работы риелтора 2.5%"
      />
    </div>
  );
};

export default DoNotKnowPriceSwapStep_1;